<template>
  <section class="period2000-2005wrap" v-parallax v-slide-up-in>
    <v-page :background="theme.colors.cyan">
      <v-chapter-years-title :pageData="info" v-slide-up-in-stage="1" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-picture-wall :data="pictures.data" v-slide-up-in-stage="2" />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      info: "",
      pictures: "",
    };
  },
  created() {
    this.pageDataItem = this.schema["2000-2005"].item;
    this.info = this.pageDataItem.info;
    this.pictures = this.pageDataItem.pictures;
  },
};
</script>
